import { render } from "./RequestList.vue?vue&type=template&id=62a0865a&scoped=true"
import script from "./RequestList.vue?vue&type=script&lang=js"
export * from "./RequestList.vue?vue&type=script&lang=js"

import "./RequestList.vue?vue&type=style&index=0&id=62a0865a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a0865a"]])

export default __exports__